import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuideArticle from "../pages/article/page";
import VersandGuide from "../pages/versand-guide/page";
import QCGuide from "../pages/qc-guide/page";
import OopbuyVsPandabuy from "../pages/oopbuy-vs-pandabuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <GuideArticle />,
  },
  {
    path: "/versand-guide",
    element: <VersandGuide />,
  },
  {
    path: "/qc-guide",
    element: <QCGuide />,
  },
  {
    path: "/oopbuy-vs-pandabuy",
    element: <OopbuyVsPandabuy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;